import styled from 'styled-components';

import { Input } from '@xsolla/ui-core';

export const FieldInputTitle = styled.div`
  color: ${(props) => props.theme.colors.muted};
`;

export const FullWideContentBlock = styled.div`
  width: 100%;
`;

export const PhoneInputWrapper = styled.div`
  position: relative;
`;

export const DropdownWrapper = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  direction: ltr;
`;

export const WrappedInput = styled(Input)<{ leftPadding: string; hovered: boolean }>`
  padding-left: ${(props) => props.leftPadding || '120px'};
  border-color: ${(props) => props.hovered && props.theme.colors.brand};
`;

export const CountrySelectWrapper = styled.div<{ readOnly: boolean }>`
  position: absolute;
  display: flex;
  justify-content: stretch;
  cursor: ${(props) => (props.readOnly ? 'default' : 'pointer')};
  align-items: center;
  padding: 8px 0 8px 8px;
  z-index: 5;
  ${(props) => props.theme.typography.descriptionCompact}
  direction: ltr;
  color: ${(props) => props.theme.colors.text};
`;

export const IconWrapper = styled.div`
  margin: 4.5px 8px 4px 4px;
  border: 0.5pt solid ${(props) => props.theme.colors.text};
`;

export const DropdownIconWrapper = styled.div`
  display: flex;
  margin-left: 4px;
  margin-right: 4px;
`;

export const SeparatingLine = styled.div`
  width: 1px;
  height: 42px;
  background-color: ${(props) => props.theme.colors.muted};
  position: absolute;
  right: 0;
`;
